import _assign from 'lodash/assign';
import _isEmpty from 'lodash/isEmpty';
import Cookies from 'universal-cookie';

import ActionTypes from '../constants/ActionTypes';
import initialState from '../store/initialState';

export default (state = initialState.report, action) => {
  switch (action.type) {
    case `${ActionTypes.GET_REPORT_SOLUTIONSET}_SUCCESS`: {
      return _assign({}, state, { reportSolutionSet: action.payload });
    }
    case `${ActionTypes.GET_REPORT_SOLUTION}_SUCCESS`: {
      const temp = JSON.parse(JSON.stringify(state.reportSolutions));
      const cookies = new Cookies();
      temp[action.payload.slug] = action.payload;
      let showCodeQualityAnnotation = cookies.get('disableCQAnnotations');

      if (
        !_isEmpty(showCodeQualityAnnotation) &&
        showCodeQualityAnnotation === '1'
      )
        showCodeQualityAnnotation = true;
      else if (
        !_isEmpty(showCodeQualityAnnotation) &&
        showCodeQualityAnnotation === '0'
      ) {
        showCodeQualityAnnotation = false;
      } else {
        showCodeQualityAnnotation = false;
        cookies.set('disableCQAnnotations', '0', { path: '/' });
      }
      return _assign({}, state, {
        reportSolutions: temp,
        showCodeQualityAnnotation,
      });
    }
    case ActionTypes.TOGGLE_REPORT_QUALITY_ANNOTATION: {
      const showCodeQualityAnnotation = !state.showCodeQualityAnnotation;
      const cookies = new Cookies();
      cookies.set(
        'disableCQAnnotations',
        showCodeQualityAnnotation ? '1' : '0',
        { path: '/' }
      );
      return _assign({}, state, {
        showCodeQualityAnnotation,
      });
    }
    default:
      return state;
  }
};
